import { ref } from 'vue'
import consumer from '../channels/consumer'

export function useConversationChannel(conversationId) {
  const subscription = ref(null)
  const callbacks = []

  const subscribe = () => {
    subscription.value = consumer.subscriptions.create(
      {
        channel: 'ConversationChannel',
        conversation_id: conversationId
      },
      {
        received(data) {
          console.log('[ActionCable] Message received:', data)
          callbacks.forEach(cb => cb(data))
        },

        connected() {
          console.log(`[ActionCable] Connected to conversation ${conversationId}`)
        },

        disconnected() {
          console.log(`[ActionCable] Disconnected from conversation ${conversationId}`)
        }
      }
    )
  }

  const onMessage = (callback) => {
    callbacks.push(callback)
  }

  const unsubscribe = () => {
    if (subscription.value) {
      subscription.value.unsubscribe()
      subscription.value = null
    }
  }

  // Don't use onUnmounted here since this is called from a store, not a component
  // The store will handle unsubscription manually

  return { subscribe, onMessage, unsubscribe }
}